// 根据id区分分享内容

import {WECHAT_SIGNATURE, WECHAT_SHARE} from './apiPath'

const appId = process.env.SHARE;
const nonceStr = 'Wm3WZYTPz0wzccnW'
/* global wx */


export default async function share(context, shareInfo) {
  const params = {
    nonceStr,
    url: encodeURIComponent(window.location.href.split('#')[0])
  }

  const data = await context.$http.get(`${WECHAT_SIGNATURE}`, {params})

  if (data.success) {
    if (!wx || !wx.config) {
      return
    }
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId, // 必填，公众号的唯一标识
      timestamp: data.data.timestamp, // 必填，生成签名的时间戳
      nonceStr, // 必填，生成签名的随机串
      signature: data.data.signature, // 必填，签名，见附录1
      jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'translateVoice'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });

    const shareConfig = {
      title: shareInfo.title || '',
      imgUrl: shareInfo.img || '',
      link: window.location.href,
      desc: shareInfo.desc || '#带你看世界，只为更美的旅程#'
    };
    // 接口取内容

    wx.ready(() => {
      let timer = 0;
      let count = 0;
      shareConfig.success = () => {
        timer = setTimeout(() => {
          context.$http.get(`${WECHAT_SHARE}`).then((res) => {
            if (res.data.success) {
              if (res.data.data) { // 今日首次分享
                console.log(res)
              }
            }
          });
        }, 500)

        if (count >= 1) {
          clearTimeout(timer);
        } else {
          count += 1;
        }
      }
      // 分享到朋友圈
      wx.updateTimelineShareData(shareConfig)
      // 分享给朋友
      wx.updateAppMessageShareData(shareConfig)
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/share.js